import React, { useEffect, useState } from 'react'
import { LocalPersistence } from '../../../../../factories';
import { Form, Row, Col, Select, message } from 'antd';
import Input from '../../../../ui/Input'
import ActionButtonsBar from '../../../../ui/ActionButtonsBar'
import { saveOrUpdateMeetingRoomsExtraFacility } from '../../../../../services/meetingrooms'
import styles from '../../index.module.css'
import Loading from "../../../../Loading";
const { Option } = Select;
const ExtraFacilityEdit = (props: any) => {
    const [form] = Form.useForm()
    const [editLoading, setEditLoading] = useState(false)
    const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
    const options = ['All Rooms','Some Rooms','No Rooms']

    const SaveClick = async() => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()

        form.validateFields().then(async(value) => {   
            setEditLoading(true)   
            let bodyQuery = {
                "supplier":session.supplier ,
                "propertyId":session.propertyId,
                "property":{
                    "meetingrooms":{
                        "meetingroomsid":props.facilityData.meetingroomsid,
                        // "meetingroomslangid":props.facilityData.meetingroomslangid,
                        "extrafacility":{
                            "overheadprojector":value.overheadprojector || '',
                            "slideprojector":value.slideprojector || '',
                            "portablemic":value.portablemic || '',
                            "stationarymic":value.stationarymic || '',
                            "lecturn":value.lecturn || '',
                            "avequipdiscount":value.avequipdiscount || '',
                            "avequipconame":value.avequipconame || '',
                            "highspeedinternet":value.highspeedinternet || '',
                            "highspeedwirelessinternet": value.highspeedwirelessinternet ||'',
                            "highspeedwirelesscharge":  value.highspeedwirelesscharge || '',
                            "highspeedinternetcharge":value.highspeedinternetcharge || '',
                            "allowotheravequip":value.allowotheravequip || '',
                            "avequipfee":value?.avequipfee || '',
                            "avequiment": value?.avequiment,
                            "soundequip": value?.soundequip,
                            "videoconf": value?.videoconf,
                            "videocamera": value?.videocamera,
                            "screenprotec": value?.screenprotec,
                            "screenperday": value?.screenperday,
                            "techsupport": value?.techsupport,
                            "teleconf": value?.teleconf,
                            "monitor": value?.monitor,
                            "microwireless": value?.microwireless,
                            "lcdprojector": value?.lcdprojector,
                            "lcdcostperday": value?.lcdcostperday,
                            "easels": value?.easels,
                            "bulletinmessageboard": value?.bulletinmessageboard,
                            "platform": value?.platform,
                            "flipchart": value?.flipchart,
                            "whiteboards": value?.whiteboards,
                        },
                    }
                }               
            }
            
            saveOrUpdateMeetingRoomsExtraFacility(bodyQuery).then(res => {
                if (res.result.success) {
                    props.setFacilityData({
                        "meetingroomsid":props.facilityData.meetingroomsid,
                        "meetingroomslangid":props.facilityData.meetingroomslangid,
                        "overheadprojector":value.overheadprojector || '',
                        "slideprojector":value.slideprojector || '',
                        "portablemic":value.portablemic || '',
                        "stationarymic":value.stationarymic || '',
                        "lecturn":value.lecturn || '',
                        "avequipdiscount":value.avequipdiscount || '',
                        "avequipconame":value.avequipconame || '',
                        "highspeedinternet":value.highspeedinternet || '',
                        "highspeedinternetcharge":value.highspeedinternetcharge || '',
                        "highspeedwirelessinternet": value.highspeedwirelessinternet ||'',
                        "highspeedwirelesscharge":  value.highspeedwirelesscharge || '',
                        "allowotheravequip":value.allowotheravequip || '',
                        "avequipfee":value?.avequipfee || '',
                        "avequiment": value?.avequiment,
                        "soundequip": value?.soundequip,
                        "videoconf": value?.videoconf,
                        "videocamera": value?.videocamera,
                        "screenprotec": value?.screenprotec,
                        "screenperday": value?.screenperday,
                        "techsupport": value?.techsupport,
                        "teleconf": value?.teleconf,
                        "monitor": value?.monitor,
                        "microwireless": value?.microwireless,
                        "lcdprojector": value?.lcdprojector,
                        "lcdcostperday": value?.lcdcostperday,
                        "easels": value?.easels,
                        "bulletinmessageboard": value?.bulletinmessageboard,
                        "platform": value?.platform,
                        "flipchart": value?.flipchart,
                        "whiteboards": value?.whiteboards, 
                    })
                    props.setEditFlag(false)
                    window.cancelEdition()
                    props.setOneNavDisabled(false)
                    getAllData()
                } else {
                    message.error({
                        content: res?.error[0]?.message || 'operation failed'
                    });
                }
                setEditLoading(false)
            }, err => {
                message.error({
                    content: err?.message || err?.error[0]?.message
                });
                setEditLoading(false)
            })
        }).catch(() => {
            setEditLoading(false)
            message.error({
                content: 'Check all the fields please.',
            });
        })  
    }

    useEffect(() => {
        getAllData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

    const getAllData = async() => {
        form.setFieldsValue({
            "overheadprojector":props.facilityData.overheadprojector ,
            "slideprojector":props.facilityData.slideprojector ,
            "portablemic":props.facilityData.portablemic ,
            "stationarymic":props.facilityData.stationarymic ,
            "lecturn":props.facilityData.lecturn ,
            "avequipdiscount":props.facilityData.avequipdiscount ,
            "avequipconame":props.facilityData.avequipconame ,
            "highspeedinternet":props.facilityData.highspeedinternet ,
            "highspeedinternetcharge":Number(props.facilityData?.highspeedinternetcharge) ? Number(props.facilityData?.highspeedinternetcharge).toFixed(2) : '',
            "allowotheravequip":props.facilityData.allowotheravequip ,
            "highspeedwirelessinternet": props.facilityData.highspeedwirelessinternet,
            "highspeedwirelesscharge": Number(props.facilityData?.highspeedwirelesscharge) ?  Number(props.facilityData?.highspeedwirelesscharge).toFixed(2) : '',
            "avequipfee":props.facilityData.avequipfee,
            "avequiment": props.facilityData.avequiment,
            "soundequip": props.facilityData.soundequip,
            "videoconf": props.facilityData.videoconf,
            "videocamera": props.facilityData.videocamera,
            "screenprotec": props.facilityData.screenprotec,
            "screenperday": Number(props.facilityData?.screenperday) ? Number(props.facilityData?.screenperday).toFixed(2) : '',
            "techsupport": props.facilityData.techsupport,
            "teleconf": props.facilityData.teleconf,
            "monitor": props.facilityData.monitor,

            "microwireless": props.facilityData.microwireless,
            "lcdprojector": props.facilityData.lcdprojector,
            "lcdcostperday": Number(props.facilityData?.lcdcostperday) ? Number(props.facilityData?.lcdcostperday).toFixed(2) : '',
            "easels": props.facilityData.easels,
            "bulletinmessageboard": props.facilityData.bulletinmessageboard,
            "platform": props.facilityData.platform,
            "flipchart": props.facilityData.flipchart,
            "whiteboards": props.facilityData.whiteboards,        
          })
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields()
        .then(() => {
          setDisabledStatus(false)
    
        }).catch((err) => {
                let savelock = false
                let s = form?.getFieldsError()
                    for (let i = 0; i < s.length; i++) {
                    if(s[i].errors.length) {
                        savelock = true;
                        break
                    }
                }
                setDisabledStatus(savelock)
        })
    }

    const highSpeedOptions = [
      'All Rooms',
      'Some Rooms',
      'No Rooms',
    ]

    const generalValues = [
      'Yes',
      'No'
    ]

    const generalOption = () => (
      <Select allowClear showSearch>
        {
          generalValues.map((value) => (
            <Option value={value}>{value}</Option>
          ))
        }
      </Select>
    )
    
    if (editLoading) return <Loading type='large' />
    return (
      <div className={styles.outCon}           
        style={{ paddingBottom: "100px" }}
      >
        <div className={styles.inCon}>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '4px' }}>Extra Facility</div>
        </div>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          initialValues={{ remember: true }}
          onValuesChange={validateFieldsError}
        >
          <Row gutter={24}> 
            <Col span={6}>
              <Form.Item
                label='AV Equipment'
                name='avequiment'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Other AV Equipment Fee'
                name='avequipfee'>
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='In-House AV Equipment Company Name'
                name='avequipconame'
                rules={[
                  () => ({
                    validator(_, value) {
                      /*
                      if (isNaN(value)) {
                        return Promise.reject("This field should be a number");
                      } */
                      if (!value) {
                        return Promise.resolve();
                      }
                      if (value.length > 128) {
                        return Promise.reject("You have reached the max character length of 128");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}>
                <Input maxLength={128}/>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Discount on In-House AV Equipment'
                name='avequipdiscount'>
                <Select allowClear showSearch>
                  <Option value='Yes'>Yes</Option>
                  <Option value='No'>No</Option>
                  <Option value='N/A'>N/A</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Overhead Projector' name='overheadprojector'>
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label='Slide Projector' name='slideprojector'>
              { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Screen for Projector'
                name='screenprotec'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Screen Charge Per Day (USD)'
                name='screenperday'
                rules={[
                  {
                    pattern: /^[0-9]*(\.[0-9]{0,8})?$/,
                    message: 'This field should be a number in USD',
                  },
                  () => ({
                    validator(_, value) {
                      /* if (!value) {
                        return Promise.reject();
                      }
                      if (isNaN(value)) {
                        return Promise.resolve();
                      }
                       */
                      if (!value) {
                        return Promise.resolve();
                      }
                      if (value.length > 8) {
                        return Promise.reject("You have reached the max character length of 8");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='LCD Projector'
                name='lcdprojector'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='LCD Cost Per Day (USD)'
                name='lcdcostperday'
                rules={[

                  {
                    pattern: /^[0-9]*(\.[0-9]{0,8})?$/,
                    message: 'This field should be a number in USD',
                  },
                  () => ({
                    validator(_, value) {
                      /*
                      if (isNaN(value)) {
                        return Promise.reject("This field should be a number");
                      } */
                      if (!value) {
                        return Promise.resolve();
                      }
                      if (value.length > 8) {
                        return Promise.reject("You have reached the max character length of 8");
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}>
                <Input maxLength={8} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Sound Equipment'
                name='soundequip'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Allows Other Audio Visual Equipment '
                name='allowotheravequip'>
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Microphones Portable' name='portablemic'>
              { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item label='Microphones Stationary' name='stationarymic'>
              { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Microphones Wireless'
                name='microwireless'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='High Speed Internet' name='highspeedinternet'>
                <Select allowClear showSearch>
                  { options.map(opt => <Option value={opt}>{ opt }</Option>) }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='High Speed Internet Charge (USD)'
                name='highspeedinternetcharge'
                rules={[
                  {
                    pattern: /^[0-9]*(\.[0-9]{0,8})?$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='High Speed Wireless Internet'
                name='highspeedwirelessinternet'>
                <Select allowClear showSearch>
                  { 
                    highSpeedOptions.map((opt) => (
                      <Option value={opt}>{ opt }</Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='High Speed Wireless Internet Charge (USD)'
                name='highspeedwirelesscharge'
                rules={[
                  {
                    pattern: /^[0-9]*(\.[0-9]{0,8})?$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Video Conferencing'
                name='videoconf'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Video Camera'
                name='videocamera'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Teleconferencing'
                name='teleconf'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Monitor'
                name='monitor'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Whiteboards'
                name='whiteboards'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Bulletin / Message Board'
                name='bulletinmessageboard'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Lecturn' name='lecturn'>
              { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Platform'
                name='platform'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Easels'
                name='easels'
                >
                { generalOption() }
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Flipchart'
                name='flipchart'
                >
                { generalOption() }
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Technical Support'
                name='techsupport'
                >
                { generalOption() }
              </Form.Item>
            </Col>

          </Row>

        </Form>
        <ActionButtonsBar
          onCancel={() => {
            props.setEditFlag(false)
            window.cancelEdition()
            props.setOneNavDisabled(false)
          }}
          onSave={SaveClick}
          disabledSave={disabledStatus}
        />
      </div>
    )
}

export default ExtraFacilityEdit
